import { useSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import Plot from 'react-plotly.js';

function PieChart({ issueTypes }) {
  const pieChartLayout = {
    font: {
      family: 'Raleway, sans-serif',
    },
    title: '',
    width: 480,
    height: 400,
    paper_bgcolor: '#f5f5f5',
    plot_bgcolor: '#f5f5f5',
    // showlegend: true,
  };
  const config = {
    responsive: true,
    displayModeBar: false,
  };

  return (
    <div
      style={{ position: 'relative', width: '480px', height: '400px' }}
      //   onMouseEnter={() => setIsToolsVisible(true)}
      //   onMouseLeave={() => setIsToolsVisible(false)}
    >
      {/* {isEditingTitle ? (
        <input
          type="text"
          value={title}
          ref={titleInputRef}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={() => handleEditTile()}
          style={{
            position: 'absolute',
            top: '32px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '5px',
            fontSize: '16px',
            zIndex: 10,
          }}
        />
      ) : (
        <div
          role="button"
          tabIndex={0}
          style={{
            position: 'absolute',
            top: '30px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '5px',
            fontSize: '18px',
            cursor: 'default',
            zIndex: 10,
            // fontWeight: '500',
          }}
          // onClick={() => setIsEditingTitle(true)}
          // onKeyDown={handleKeyDown}
        >
          {title !== '' ? title : `Analysis of ${props?.data[0]?.yaxis_name} by ${props?.data[0]?.xaxis_name}`}
        </div>
      )} */}
      <Plot
        data={[
          {
            values: [issueTypes.missing, issueTypes.invalidData, issueTypes.inconsistent],
            labels: ['Missing', 'Invalid Data', 'Inconsistent'],
            type: 'pie',
            hole: 0.4,
            hoverinfo: 'label+percent',
          },
        ]}
        config={config}
        layout={pieChartLayout}
      />
      {/* {isToolsVisible && (
        <>
          <Tooltip title="Edit Title" placement="right">
            <button
              style={{
                position: 'absolute',
                top: '12%',
                right: '10px',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                border: 'none',
                background: 'none',
                padding: '0',
                outline: 'none',
                // color: 'grey',
              }}
              onClick={() => {
                setIsEditingTitle(true);
              }}
            >
              <FaEdit />
            </button>
          </Tooltip>
          <Tooltip title="View Data">
            <button
              style={{
                position: 'absolute',
                top: '19%',
                right: '10px',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                border: 'none',
                background: 'none',
                padding: '0',
                outline: 'none',
                // color: 'grey',
              }}
              onClick={() => {
                setIsViewTable(true);
              }}
            >
              <FaInfoCircle />
            </button>
          </Tooltip>
          <Tooltip title="Delete Tile">
            <button
              style={{
                position: 'absolute',
                top: '90%',
                right: '20px',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                border: 'none',
                background: 'none',
                padding: '0',
                outline: 'none',
              }}
              onClick={() => {
                handleDeleteTile(props?.rg_id);
              }}
            >
              <FaTrashAlt />
            </button>
          </Tooltip>
        </>
      )} */}

      {/* {isViewTable && (
        <ViewTable
          props={props?.data[0]}
          fileName={props?.fileName}
          setIsViewTable={setIsViewTable}
          title={props.title}
        />
      )} */}
    </div>
  );
}

export default PieChart;
